angular.
module("dx.webapp.answer").
factory("DxAnswer", function answerService(
	DX_QUESTION_TYPE,
	DxGrade,

	DxAnswerBlock
) {
	"use strict";

	function instantiateAnswerBlock(data) {
		return new DxAnswerBlock(data, true);
	}

	return function Answer(data) {
		if (!(this instanceof Answer)) {
			throw new Error("Constructor must be called with 'new'.");
		}

		angular.extend(this, {
			id: 0,
			type: 0,
			data: "",
			answerBlocks: [],
			images: [],
			attachments: null,
			grade: null,
		});

		if (data) {
			angular.extend(this, data);
		}

		this.grade = new DxGrade(this.grade);

		if (this.answerBlocks) {
			this.answerBlocks = this.answerBlocks.map(instantiateAnswerBlock);
		}

		var dirty = false;

		this.isDirty = function isDirty() {
			return dirty;
		};

		this.setDirty = function setDirty(state) {
			dirty = state;
		};

		this.isGraded = function isGraded() {
			return this.grade.isGraded();
		};

		this.isPartial = function isPartial() {
			return this.grade.note.length > 0 && !this.isGraded();
		};

		this.hasAnswer = function hasAnswer() {
			function blockHasText(block) {
				return !!block.body.length;
			}

			function blockIsSvg(block) {
				return block.type === "svg";
			}

			var answerData = this.data;
			var attachments = this.attachments;


			switch (this.type) {
				case DX_QUESTION_TYPE.TEXT:
					return this.answerBlocks.some(blockHasText) ||
						this.answerBlocks.some(blockIsSvg) ||
						attachments && attachments.length > 0;
				case DX_QUESTION_TYPE.SINGLE_CHOICE:
					return typeof answerData === "number" && answerData > 0;
				case DX_QUESTION_TYPE.MULTIPLE_CHOICE:
					return Array.isArray(answerData) && answerData.length;
				case DX_QUESTION_TYPE.WORD_GAP:
					if (!Array.isArray(answerData)) {
						return false;
					}

					for (var i = 0; i < answerData.length; i++) {
						var phrase = answerData[i].phrase;
						if (phrase && phrase.trim() !== "") {
							return true;
						}
					}

					return false;
				default:
					return false;
			}
		};

		this.wordCount = function wordCount() {
			function addBlockWordCount(value, block) {
				var ret = value + block.wordCount || 0;
				return ret;
			}

			return this.answerBlocks.reduce(addBlockWordCount, 0);
		};
	};
});
